import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaScroll,
  FaChartPie,
  FaSignInAlt,
  FaArrowAltCircleLeft,
  FaBook,
  FaUserGraduate,
  FaCog,
  FaClipboardCheck,
  FaInbox,
  FaTasks,
  FaChevronDown,
} from "react-icons/fa";
import axios from "axios";
import "./style.css";
import { jwtDecode } from 'jwt-decode';
import { API_ENDPOINTS, API_BASE_URL } from '../../../js/api.js';

const getProgramaVinculado = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    const tipoPrograma = Number(decoded.tipo_programa);
    const tipo = decoded.tipo;
    if (tipo === "usuario_ciee") {
      return {
        tipo: 99,
        nome: "Dashboard",
        link: "/dashboard",
        icone: "chart",
        cor: "#9333ea",
      };
    }
    switch (tipoPrograma) {
      case 0:
        return {
          tipo: 0,
          nome: "Estágio (TCE)",
          link: "/tce",
          icone: "user",
          cor: "#0ea5e9",
        };
      case 1:
        return {
          tipo: 1,
          nome: "Aprendizagem (TCA)",
          link: "/tca",
          icone: "book",
          cor: "#16a34a",
        };
      case 2:
        return {
          tipo: 2,
          nome: "Aprendizagem CIEEMG Empregador",
          link: "/tca-empregador",
          icone: "book",
          cor: "#16a34a",
        };
      default:
        return null;
    }
  } catch (e) {
    return null;
  }
};

const getTipoUsuario = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return jwtDecode(token).tipo;
  } catch {
    return null;
  }
};

// Identifica se o usuário logado é estudante (nível 1). O JWT pode ter
// `tipo === "estudante"` e/ou `acesso_autorizacao === 1` (padronizado em
// src/frontend/pages/Inicial/index.js).
const getIsEstudante = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    if (decoded.tipo === "estudante") return true;
    if (Number(decoded.acesso_autorizacao) === 1) return true;
    return false;
  } catch {
    return false;
  }
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const programa = getProgramaVinculado();
  const tipoUsuario = getTipoUsuario();
  const isEstudante = getIsEstudante();
  const [qtdNovos, setQtdNovos] = useState(0);
  const [validacoesAberto, setValidacoesAberto] = useState(false);
  const dropdownRef = useRef(null);

  // Polling do badge (só pra CIEE)
  useEffect(() => {
    if (tipoUsuario !== "usuario_ciee") return;
    const token = localStorage.getItem("token");
    if (!token) return;

    const buscarNovos = () => {
      axios.get(`${API_BASE_URL}/tca/validacoes/novos`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => setQtdNovos((r.data || []).length))
        .catch(() => setQtdNovos(0));
    };

    buscarNovos();
    const interval = setInterval(buscarNovos, 30000);
    return () => clearInterval(interval);
  }, [tipoUsuario]);

  // Abre dropdown automaticamente quando estiver em uma rota /validacoes/*
  useEffect(() => {
    if (location.pathname.startsWith("/validacoes")) {
      setValidacoesAberto(true);
    }
  }, [location.pathname]);

  // Fecha dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setValidacoesAberto(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    try {
      window.localStorage.clear();
      window.sessionStorage.clear();
    } catch (_) {}
    window.location.href = "/";
  };

  const handleProgramaClick = (e) => {
    if (!programa) return;
    e.preventDefault();
    navigate(programa.link);
  };

  const renderIcone = () => {
    if (!programa) return null;
    if (programa.icone === "user") return <FaUserGraduate size={25} />;
    if (programa.icone === "book") return <FaBook size={25} />;
    return <FaScroll size={25} />;
  };

  const noValidacoes = location.pathname.startsWith("/validacoes");

  return (
    <nav className="menu-v" id="menu-v">
      <div className="div-logo-menu">
        <img src="./logociee.png" />
      </div>

      <div className="menu-v-option-sidebar">
        <div className="dropdown">
          <button
            className="dropbtn-vertical-sidebar"
            onClick={() => navigate("/dashboard")}
          >
            <span className="icon">
              <FaArrowAltCircleLeft size={25} />
            </span>
            <span className="txt-link-sidebar">Home</span>
          </button>
        </div>

        {/* Estudante (nível 1) NÃO vê os itens de Histórico, Acompanhamento,
            programa-atual, Validações ou Configurações. Apenas Home e Sair. */}
        {!isEstudante && programa && programa.tipo !== 99 && (
          <div className="dropdown">
            <button
              className="dropbtn-vertical-sidebar programa-atual"
              onClick={handleProgramaClick}
              style={{ borderLeft: `4px solid ${programa.cor}` }}
            >
              <span className="icon" style={{ color: programa.cor }}>
                {renderIcone()}
              </span>
              <span className="txt-link-sidebar">{programa.nome}</span>
            </button>
          </div>
        )}

        {!isEstudante && (
          <div className="dropdown">
            <button
              className={`dropbtn-vertical-sidebar ${location.pathname === "/historico-eventos" ? "sidebar-item-ativo" : ""
                }`}
              onClick={() => navigate("/historico-eventos")}
            >
              <span className="icon">
                <FaScroll size={25} />
              </span>

              <span className="txt-link-sidebar">Histórico</span>
            </button>
          </div>
        )}
        {!isEstudante && (
          <div className="dropdown">
            <button
              className="dropbtn-vertical-sidebar"
              onClick={() => navigate("/acompanhamento")}
            >
              <span className="icon">
                <FaChartPie size={25} />
              </span>
              <span className="txt-link-sidebar">Acompanhamento</span>
            </button>
          </div>
        )}

        {!isEstudante && tipoUsuario === "usuario_ciee" && (
          <div className="dropdown sidebar-dropdown" ref={dropdownRef}>
            <button
              className={`dropbtn-vertical-sidebar sidebar-dropdown-btn ${noValidacoes ? "sidebar-dropdown-ativo" : ""}`}
              onClick={() => {
                setValidacoesAberto(false);
                navigate("/validacoes");
              }}
              style={{ position: "relative" }}
            >
              <span className="icon">
                <FaClipboardCheck size={25} />
              </span>
              <span className="txt-link-sidebar">Validações</span>
              {qtdNovos > 0 && (
                <span className="badge-sidebar">{qtdNovos}</span>
              )}

            </button>
          </div>
        )}

        {!isEstudante && tipoUsuario === "usuario_ciee" && (
          <div className="dropdown">
            <button
              className="dropbtn-vertical-sidebar"
              onClick={() => navigate("/tca-configuracoes")}
            >
              <span className="icon">
                <FaCog size={25} />
              </span>
              <span className="txt-link-sidebar">Configurações</span>
            </button>
          </div>
        )}
      </div>

      <div className="menu-option-logout">
        <div className="dropdown">
          <button className="dropbtn-vertical-sidebar" onClick={handleLogout}>
            <span className="icon icon-sair">
              <FaSignInAlt size={25} />
            </span>
            <span className="txt-link-sidebar">Sair</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
